<div class="container">
  <div class="row">
    <div class="col col-12">
      <div class="accessories-middle">
        @if ($mandatoryAccessories()) {
          <boels-accessories-view
            [label]="
              'productDetails.productAccessoriesTab.mandatoryAccessoriesTitle'
            "
            [sublabel]="
              'productDetails.productAccessoriesTab.mandatoryAccessoriesIntro'
            "
            [accessories]="$mandatoryAccessories()"
            [pdpView]="true"
            [ngClass]="'accessories-tab mandatoryAccessories'"
            [accordionMode]="accordionMode"
          >
          </boels-accessories-view>
        }
        @if ($optionalAccessories()) {
          <boels-accessories-view
            [label]="
              'productDetails.productAccessoriesTab.optionalAccessoriesTitle'
            "
            [sublabel]="
              'productDetails.productAccessoriesTab.optionalAccessoriesIntro'
            "
            [accessories]="$optionalAccessories()"
            [pdpView]="true"
            [ngClass]="'accessories-tab optionalAccessories'"
            [accordionMode]="accordionMode"
          >
          </boels-accessories-view>
        }
      </div>
    </div>
  </div>
</div>
